import Episode from "./Episode";
import {useEffect} from "react";
import {useEpisodes} from "../../hooks/UseEpisodes";

function EpisodeList(params) {
    const user = params.user;
    const serialId = params.serialId;
    const episodesHook = useEpisodes();

    useEffect(() => {
        episodesHook.loadEpisodes(user.token, serialId);
    }, [serialId, user.token]);

    if (!episodesHook.episodes)
        return <div style={{ textAlign: 'center', padding: '10px', fontSize: '12px', color: '#6b7280' }}>Завантаження...</div>;

    const episodesElements = episodesHook.episodes
        .sort((a, b) => a.serialOrder - b.serialOrder)
        .map(m => <Episode episode={m} key={m.id}/>);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2px',
            padding: '5px',
            backgroundColor: '#f9fafb',
            borderRadius: '8px'
        }}>
            {episodesElements.length > 0 ? episodesElements : "Серій ще немає"}
        </div>
    );
}

export default EpisodeList;